var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgTone = function SvgTone(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.536 8.464c.688-.688 1.032-1.032.96-1.528-.07-.495-.428-.69-1.142-1.08a7 7 0 0 0-9.498 9.498c.39.714.585 1.072 1.08 1.143s.84-.273 1.528-.961L12 12z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTone);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;